module.exports = __webpack_public_path__ + "img/P90X3.afa59c1f.png";